import { DomElementBase } from "./DomElementBase";
import { DomLayerElementInterface } from "../config/DomLayerElementInterface";
import { DomElementFrameInterface } from "../config/DomElementFrameInterface";
import { DomLayer } from "../dom-layer";

export class DomElementImage extends DomElementBase {
    constructor(
        domLayer: DomLayer,
        imageDirPath: string,
        options: DomLayerElementInterface,
        defaultOptions: DomLayerElementInterface,
        frames: DomElementFrameInterface[]
    ) {
        super(domLayer, imageDirPath, options, defaultOptions, frames);
        this.postInit();
    }

    public updateStateVariable(state: any[]) {
        super.updateStateVariable(state);
        if (this.stateVariable) {
            const currentStateValue = this.stateVariable[1];
            if (state[1] === currentStateValue) {
                if (this.element && !this.element.parentElement)
                    this.domLayer.domDiv.appendChild(this.element);
            } else {
                if (this.element && this.element.parentElement)
                    this.domLayer.domDiv.removeChild(this.element);
            }
        }
    }

    protected postInit() {
        if (this.stateVariable) {
            const stateName = this.stateVariable[0];
            const stateValue = this.stateVariable[1];
            const globalStateValue = this.domLayer.getStateVariable(stateName);
            if (globalStateValue !== stateValue) this.hideElement = true;
        }
    }
}
